.warning{background-color:#ff0}
/*# sourceMappingURL=modal-confirm.component-6VQ7Y5Y7.css.map */
